<template>
<div class="chapter">
<div class="inner_page">
<div class="ch-box">
<h2 class="part-title">What’s Happening to Our Children’s Health?</h2>
<p class="part-image"><img alt="image" src="images/p15.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?e99a0ce0